import { z } from "zod";

export const welcomeSchema = z.object({
  email: z.string().email(),
});

export type WelcomeFormData = z.infer<typeof welcomeSchema>;
